import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lh-sign-up-success',
  templateUrl: './sign-up-success.component.html',
  styleUrls: ['./sign-up-success.component.scss'],
})
export class SignUpSuccessComponent implements OnInit {
  logoUrl!: string;
  userEmailAddress = '';

  constructor(private activatedRoute: ActivatedRoute) {
    this.userEmailAddress = this.activatedRoute.snapshot.queryParams['email'] || '';
  }

  ngOnInit(): void {
    this.logoUrl = 'assets/logos/brand-logo.svg';
  }
}
